import { industries } from '@/mocks/home';
import SectionHead from './SectionHead';

export default function Industries() {
  return (
    <section id="industries" className="bg-background-50">
      <div className="max-w-[1280px] mx-auto px-5 md:px-10 lg:px-12 py-24 md:py-32">
        <SectionHead label="Industries We Serve" title="BUILT FOR THE SYSTEMS THAT MATTER." />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-14 mt-14 md:mt-20">
          {industries.map((ind) => (
            <article key={ind.name} className="group">
              <div data-mo="image" className="r-img w-full aspect-[16/10]">
                <img src={ind.image} alt={`${ind.name} industrial valve applications`} title={`${ind.name} - NORTHLINE`} className="w-full h-full object-cover object-top group-hover:scale-[1.02] transition-transform duration-700 ease-[cubic-bezier(0.22,1,0.36,1)]" />
              </div>
              <h3 className="mt-6 t-feature text-foreground-950">{ind.name}</h3>
              <p className="mt-2 t-body text-foreground-600 max-w-md">{ind.body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}